import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { InterviewDataService } from './services/interview-data.service';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'practice-complete',
    templateUrl: './practice-complete.component.html',
    standalone: false
})
export class PracticeCompleteComponent implements OnInit, AfterViewInit {
    private translate = inject(TranslateService);
    attemptId: any;

    constructor(public _dataService: InterviewDataService) {}

    ngOnInit() {
        this.attemptId = this._dataService.attemptId;
    }

    ngAfterViewInit() {
        document.title = this.translate.instant('interviews.Practice Complete');
        (document.querySelector('.mock-interviews-header h1') as HTMLElement)?.focus();
    }
}
